module.exports = __webpack_public_path__ + "static/img/avatar.86d1477d.png";